<div class="grid p-fluid">
	<!-- NO SITE SELECTED ALERT -->
	<div *ngIf="currentSite === undefined" class="col-12 pb-0">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<i class="pi cm-alert text-lg text-yellow-700"></i>
			<p-tag [value]="('NO_SITE_DEVICE_ALERT' | translate)" severity="warning"></p-tag>
		</div>
	</div>
	<!-- SHARED SITE ALERT -->
	<div *ngIf="currentSite !== undefined && !currentSite.CurrentlyOwned" class="col-12 pb-0">
		<div class="flex align-items-center justify-content-center bg-purple-100 p-1 border-round-xl">
			<i class="pi cm-share text-lg text-purple-700"></i>
			<p-tag [value]="('SHARED_SITE' | translate)" styleClass="p-tag-purple"></p-tag>
		</div>
	</div>
	<!-- TIMEZONE SITE NOT SET -->
	<div *ngIf="timezoneNotSet() && currentSite?.CurrentlyOwned" class="col-12 pb-0">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<p-tag icon="pi cm-alert" [value]="('TIMEZONE_NOT_SET_WARNING' | translate)" severity="warning"></p-tag>
		</div>
	</div>
	<!-- ADD GATEWAY / HIDDEN IF IS SHARED SITE -->
	<div *ngIf="currentSite !== undefined && currentSite?.CurrentlyOwned" class="col-12 pb-0">
		<div class="flex justify-content-center">
			<p-button id="buttonAddDevice" label="{{ 'ADD_DEVICE' | translate }} {{ 'GATEWAY' | lowercase | translate }}"
				(click)="addGateway()" icon="pi cm-plus"
				[rounded]="false" [text]="true" severity="primary"
				styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
			</p-button>
		</div>
	</div>
	<div class="col-12" [class]="onExtendedMobile() ? 'px-0' : ''">
		<p-tabView [scrollable]="true" [activeIndex]="activeIndex" (onChange)="selectedIndexChange($event)"
			styleClass="transparent-tabView">
			<!-- AUTOMATIONS -->
			<p-tabPanel header="{{ 'LIST_DEVICE_AUTOMATIONS' | translate }}">
				<app-device-treetable class="pt-0"></app-device-treetable>
			</p-tabPanel>
			<!-- THERMO -->
			<p-tabPanel header="{{ 'LIST_DEVICE_THERMO' | translate }}">
				<app-devices-th-list></app-devices-th-list>
			</p-tabPanel>
			<!-- VCT -->
			<p-tabPanel header="{{ 'LIST_DEVICE_VCT' | translate }}" *ngIf="!isImpersMode">
				<app-devices-vct-list *ngIf="!editSystem"></app-devices-vct-list>
				<app-devices-vct-list-edit *ngIf="editSystem"></app-devices-vct-list-edit>
			</p-tabPanel>
		</p-tabView>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<!-- <button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button> -->
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>